(() => {
  const PRODUCT_TITLE = 'Fällkeil Forst Set 5-teilig';
  const BASE_LABEL = '5-teiliges Set';
  const DOUBLE_LABEL = '2x 5-teiliges Set';
  const productCache = new Map();

  function isTargetProduct() {
    const h1 = document.querySelector('h1, .product-title, [class*="title"]');
    return h1 && h1.textContent && h1.textContent.includes(PRODUCT_TITLE);
  }

  function getSelectedLabel() {
    const checked = document.querySelector('input[type="radio"]:checked');
    if (checked) {
      const label = checked.id ? document.querySelector(`label[for="${CSS.escape(checked.id)}"]`) : null;
      const text = (label || checked.closest('label'))?.textContent?.trim();
      if (text) return text;
    }

    const selected = Array.from(document.querySelectorAll('[aria-pressed="true"], [aria-checked="true"], .is-selected, .selected'))
      .find((el) => (el.textContent || '').includes(BASE_LABEL) || (el.textContent || '').includes(DOUBLE_LABEL));

    if (selected) return selected.textContent.trim();

    return document.body.innerText.includes(DOUBLE_LABEL) && window.location.href.includes('53148673638730') ? DOUBLE_LABEL : BASE_LABEL;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.style.display = hidden ? 'none' : '';
  }

  function ensureDoubleCompare(priceList) {
    const salePrice = priceList.querySelector('sale-price');
    if (!salePrice) return;

    let discount = salePrice.querySelector('.ji-discount');
    if (!discount) {
      discount = document.createElement('span');
      discount.className = 'ji-discount absina-fallkeil-added';
      discount.style.cssText = 'color:#1f9d4e;font-weight:600;margin-right:6px;';
      discount.textContent = '-5%';
      salePrice.insertBefore(discount, salePrice.firstChild);
    }

    let compare = priceList.querySelector('compare-at-price.ji-compare');
    if (!compare) {
      compare = document.createElement('compare-at-price');
      compare.className = 'ji-compare text-sm absina-fallkeil-added';
      compare.style.cssText = 'display:block;flex-basis:100%;width:100%;order:2;margin-top:-6px;text-align:left;line-height:1.1;';
      compare.innerHTML = '<span class="sr-only">Regulärer Preis</span><span class="ji-compare-prefix" style="color:#6b7280;font-weight:400;margin-right:4px;">Statt:</span><span class="ji-compare-value" style="text-decoration:line-through;color:rgb(var(--on-sale-text));">39,98€</span>';
      salePrice.insertAdjacentElement('afterend', compare);
    }

    setHidden(discount, false);
    setHidden(compare, false);
  }

  function applyFallkeilFix() {
    if (!isTargetProduct()) return;

    const label = getSelectedLabel();
    const isDouble = label.includes(DOUBLE_LABEL) || window.location.href.includes('53148673638730');
    const isBase = !isDouble;

    document.querySelectorAll('price-list').forEach((priceList) => {
      const discount = priceList.querySelector('.ji-discount');
      const compare = priceList.querySelector('compare-at-price.ji-compare, compare-at-price');
      const unitPill = priceList.querySelector('.ji-unit-pill');

      if (isBase) {
        setHidden(discount, true);
        setHidden(compare, true);
        setHidden(unitPill, true);
      } else {
        ensureDoubleCompare(priceList);
        setHidden(unitPill, false);
      }
    });
  }

  async function applyGenericStaffelCompare() {
    if (!document.body.classList.contains('template-product') && !document.querySelector('.shopify-section--main-product')) return;
    if (isTargetProduct()) return;

    const product = await getCurrentProductJson();
    if (!product || !Array.isArray(product.variants) || product.variants.length < 2) return;

    const variant = getSelectedVariant(product);
    if (!variant) return;

    const staffelIndex = getStaffelOptionIndex(product);
    if (staffelIndex < 0) return;

    const selectedUnits = parseUnits(variant.options?.[staffelIndex]);
    if (!selectedUnits) return;

    const matchingVariants = product.variants.filter((candidate) => sameNonStaffelOptions(candidate, variant, staffelIndex));
    const unitRows = matchingVariants
      .map((candidate) => ({ variant: candidate, units: parseUnits(candidate.options?.[staffelIndex]) }))
      .filter((row) => row.units > 0);

    if (unitRows.length < 2) return;

    const baseUnits = Math.min(...unitRows.map((row) => row.units));
    const baseUnitPrice = Math.max(...unitRows.map((row) => cents(row.variant.price) / row.units));
    const price = cents(variant.price);
    const syntheticCompare = Math.round(baseUnitPrice * selectedUnits);
    const variantCompare = cents(variant.compare_at_price);
    const compare = selectedUnits > baseUnits ? Math.max(syntheticCompare, variantCompare) : 0;

    getMainPriceLists().forEach((priceList) => {
      if (compare > price) {
        showCompare(priceList, price, compare);
      } else {
        hideAddedCompare(priceList);
      }
    });
  }

  function getCurrentProductJson() {
    const handle = getProductHandle();
    if (!handle) return Promise.resolve(null);
    if (productCache.has(handle)) return productCache.get(handle);

    const promise = fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then((response) => response.ok ? response.json() : null).catch(() => null);

    productCache.set(handle, promise);
    return promise;
  }

  function getProductHandle() {
    const pickerHandle = document.querySelector('variant-picker[handle]')?.getAttribute('handle');
    if (pickerHandle) return pickerHandle;

    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
    const match = canonical.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getSelectedVariant(product) {
    const formId = document.querySelector('variant-picker[form-id]')?.getAttribute('form-id');
    const formVariantId = formId ? document.querySelector(`form#${cssEscape(formId)} [name="id"]`)?.value : '';
    const anyVariantId = formVariantId || document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    const scriptVariant = readCurrentVariantScript();
    const id = anyVariantId || urlVariantId || scriptVariant?.id;

    if (id) {
      const matched = product.variants.find((candidate) => String(candidate.id) === String(id));
      if (matched) return matched;
    }

    return scriptVariant && product.variants.find((candidate) => String(candidate.id) === String(scriptVariant.id)) || product.variants.find((candidate) => candidate.available) || product.variants[0];
  }

  function readCurrentVariantScript() {
    const script = document.querySelector('variant-picker script[data-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  function getStaffelOptionIndex(product) {
    const names = Array.isArray(product.options) ? product.options : [];

    for (let index = 0; index < names.length; index += 1) {
      const name = String(names[index] || '').toLowerCase();
      const values = product.variants.map((variant) => String(variant.options?.[index] || '').toLowerCase());
      const nameMatches = /anzahl|menge|pack|stück|stueck|teilig|teile|tlg|set|paar/.test(name);
      const valueMatches = values.some((value) => /\d+\s*x|\d+\s*er\b|\d+\s*[- ]?(teilig|teile|tlg|stück|stueck|pack|set|paar)/.test(value));

      if (nameMatches || valueMatches) return index;
    }

    return -1;
  }

  function sameNonStaffelOptions(candidate, selected, staffelIndex) {
    const candidateOptions = candidate.options || [];
    const selectedOptions = selected.options || [];

    return selectedOptions.every((value, index) => index === staffelIndex || String(candidateOptions[index]) === String(value));
  }

  function parseUnits(value) {
    const text = String(value || '').toLowerCase().replace(/spare\s+\d+%/g, '').replace(/du sparst.*$/g, '').trim();
    if (!text) return 0;

    return text.split('+').reduce((sum, part) => sum + parseUnitPart(part), 0);
  }

  function parseUnitPart(part) {
    const text = String(part || '').trim();
    if (!text) return 0;

    const multiplied = text.match(/(\d+)\s*x\s*(\d+)\s*(?:er\b|[-\s]*(?:teilig|teile|tlg|stück|stueck|pack|set|paar))/);
    if (multiplied) return Number(multiplied[1]) * Number(multiplied[2]);

    const direct = text.match(/(\d+)\s*(?:er\b|[-\s]*(?:teilig|teile|tlg|stück|stueck|pack|set|paar))/);
    if (direct) return Number(direct[1]);

    const multiplierOnly = text.match(/(\d+)\s*x\b/);
    if (multiplierOnly) return Number(multiplierOnly[1]);

    const firstNumber = text.match(/\d+/);
    return firstNumber ? Number(firstNumber[0]) : 0;
  }

  function getMainPriceLists() {
    const lists = Array.from(document.querySelectorAll('.product-info__block-item[data-block-type="price"] price-list, .product-info__price price-list'));
    return lists.length ? lists : Array.from(document.querySelectorAll('.shopify-section--main-product .product-info price-list')).slice(0, 2);
  }

  function showCompare(priceList, price, compare) {
    const salePrice = priceList.querySelector('sale-price');
    if (!salePrice) return;

    const discountValue = Math.round(((compare - price) * 100) / compare);
    const discounts = Array.from(salePrice.querySelectorAll('.ji-discount'));
    let discount = discounts.find((element) => !element.classList.contains('absina-staffel-added')) || discounts[0];
    discounts.forEach((element) => {
      if (element !== discount) element.remove();
    });

    if (!discount) {
      discount = document.createElement('span');
      discount.className = 'ji-discount absina-staffel-added';
      discount.style.cssText = 'color:#1f9d4e;font-weight:600;margin-right:6px;';
      const srOnly = salePrice.querySelector('.sr-only');
      if (srOnly) srOnly.insertAdjacentElement('afterend', discount);
      else salePrice.insertBefore(discount, salePrice.firstChild);
    }

    discount.textContent = `-${discountValue}%`;
    discount.style.removeProperty('display');

    let compareEl = priceList.querySelector('compare-at-price.ji-compare');
    if (!compareEl) {
      compareEl = document.createElement('compare-at-price');
      salePrice.insertAdjacentElement('afterend', compareEl);
    }

    compareEl.className = 'ji-compare text-sm absina-staffel-added';
    compareEl.style.cssText = 'display:block;flex-basis:100%;width:100%;order:2;margin-top:-6px;text-align:left;line-height:1.1;';
    compareEl.innerHTML = `<span class="sr-only">Regulärer Preis</span><span class="ji-compare-prefix" style="color:#6b7280;font-weight:400;margin-right:4px;">Statt:</span><span class="ji-compare-value" style="text-decoration:line-through;color:rgb(var(--on-sale-text));">${formatMoney(compare)}</span>`;
  }

  function hideAddedCompare(priceList) {
    priceList.querySelectorAll('.absina-staffel-added').forEach((element) => element.remove());
  }

  function cents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'string') {
      const normalized = value.trim().replace(',', '.');
      if (normalized.includes('.')) return Math.round(Number(normalized) * 100) || 0;
    }
    return Number(value) || 0;
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents(value) / 100).replace(/\s/g, '');
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/"/g, '\\"');
  }

  function schedule() {
    window.setTimeout(() => {
      applyGenericStaffelCompare();
      applyFallkeilFix();
    }, 80);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('variant:change', schedule, true);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();